<xemex-page-header
  [title]="companyStore.companyDetail().partnerName"
  [subtitle]="companyStore.companyDetail().partnerType"
  [breadcrumbs]="breadcrumbs"
  [loading]="companyStore.isLoadingDetail()"
  [withBackground]="true"
  [withTabBar]="true"
  [icon]="'domain'"
>
  <xemex-tab-bar
    [tabs]="PARTNER_DETAIL_TABS_VIEW"
    [defaultTab]="0"
    (tabChange)="onTabChange($event)"
  ></xemex-tab-bar>
</xemex-page-header>

<!-- General Tab Content -->
@if (selectedTab === 'general') {
  <xemex-page-body [scrollable]="true">
    <xemex-company-general-tab
      [companyDetail]="companyStore.companyDetail()"
      [isLoading]="companyStore.isLoadingDetail()"
      [isXemex]="isXemex"
      [isOwnPartner]="isOwnPartner"
    >
    </xemex-company-general-tab>
  </xemex-page-body>
}

<!-- Users Tab Content -->
@if (selectedTab === 'users') {
  <xemex-page-body [scrollable]="false">
    <xemex-company-users-tab
      [users]="users.users"
      [totalUsers]="users.numberOfItems"
      [permissions]="permissions()"
      [isLoading]="companyStore.isGettingUsers()"
      (createUser)="onCreateUserClicked()"
      (editUser)="onEditUserClicked($event)"
      (deleteUser)="onDeleteUser($event)"
      (pageChange)="onPageChange($event)"
      (resendInvite)="onResendInvite($event)"
    >
    </xemex-company-users-tab>
  </xemex-page-body>
}
